import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {Merchant} from "../MerchantStore";
import type {StoreId} from "../../../stem-core/state/State";


@globalStore
export class MerchantFees extends BaseStore("MerchantFees") {
    @field(Number) merchantId: number;
    @field("Merchant") merchant: Merchant;
    @field(Number) purchaseFee: number;
    @field(Number) subscriptionFee: number;
    @field(Number) donationFee: number;
}

// What AdminUpdateMerchantFeesRequest validates (admin_api/views/merchants.py:49). All three are required,
// each a percentage between 0 and 30. A fee is a number as loaded and the text input's string once edited
// in EditableCard; the backend parses either as a Decimal
export interface AdminUpdateMerchantFeesRequest {
    merchantId: StoreId;
    purchaseFee: number | string;
    subscriptionFee: number | string;
    donationFee: number | string;
}

export async function apiAdminUpdateMerchantFees(data: AdminUpdateMerchantFeesRequest) {
    return apiClient.post("admin/merchants/update_fees/", data);
}
